import styled from 'styled-components';
import { mediaMax } from 'themes/helpers';
import rsvpLine from 'images/line-rsvp.png';

export const StyledHeader = styled.section`
  background-color: rgba(21, 20, 18, 0.9);
  position: fixed;
  top: 0; left: 0; bottom: 0; right: 0;
  z-index: 300;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  > div {
    width: calc(100% / 3);
  }
  .logo-awc {
    img {
      height: 38px;
    }
  }
  .logo-afterhours {
    display: flex;
    justify-content: center;
    opacity: 0;
    transition: opacity .25s;
    img {
      height: 60px;
    }
  }
  .rsvp {
    display: flex;
    justify-content: flex-end;
    button {
      position: relative;
      font-size: 2.6em;
      font-weight: bold;
      letter-spacing: 1.13px;
      text-transform: uppercase;
      padding-bottom: 12px;
      cursor: pointer;
      &:after {
        content: "";
        position: absolute;
        bottom: 0; left: 0; right: 0;
        width: 100%;
        height: 12px;
        background: url(${rsvpLine}) no-repeat center center;
        background-size: contain;
      }
    }
  }
  ${mediaMax.phoneL`
    height: 60px;
    padding: 0 15px;
    > div {
      width: auto;
    }
    .logo-awc {
      img {
        height: 30px;
      }
    }
    .logo-afterhours {
      display: none;
    }
    .rsvp {
      button {
        font-size: 2em;
      }
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Header/styles.js